import {faChevronsRight} from "@fortawesome/pro-solid-svg-icons/faChevronsRight";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ErrorMessage} from "@hookform/error-message";
import {Button, ColourSolid, ValidationError} from "@twigsby/frontend-framework";
import {Controller, useFormContext} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React from "react";

export type RulesetScanTypeType = {
    name: string;
}

const ThingList = [
    { label: 'Content', value: 0 },
    { label: 'Envelope', value: 1 },
    { label: 'All', value: 2 },
]

const RulesetScanType = (props: RulesetScanTypeType) => {
    const { control, getFieldState, getValues, formState } = useFormContext();

    return (
        <div className={`thing-action mb-sm ${getFieldState(props.name).invalid ? 'invalid' : ''}`}>
            <input type={'text'} readOnly={true} defaultValue={'Mail Scans'} />
            <div className={'thing-icon'}>
                <FontAwesomeIcon icon={faChevronsRight} fixedWidth={true} className={'hidden'} />
            </div>
            <div className={'thing-types'}>
                <Controller
                    control={control}
                    name={props.name}
                    defaultValue={getValues(props.name)}
                    rules={{ required: true, validate: (val) => val === -1 ? "Mail Scan Type is required" : true }}
                    render={({ field, fieldState }) =>
                        <>
                            {ThingList.map((thing, index) =>
                                <Button
                                    key={`ruleScanType${index}`}
                                    title={thing.label}
                                    fullWidth={true}
                                    squared={true}
                                    onClick={() => field.onChange(index)}
                                    colour={getValues(props.name) === index ? ColourSolid.Selected : ColourSolid.Secondary}
                                />
                            )}
                        </>
                    }
                />
            </div>

            <ErrorMessage
                errors={formState.errors}
                name={props.name}
                render={({ message }) => <ValidationError value={message} />}
            />

        </div>
    )
}

export { RulesetScanType }
